import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHuaweiComponent } from './simple-icons-huawei.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHuaweiComponent ],
    exports:      [ SimpleIconsHuaweiComponent ],
    bootstrap:    []
})
export class SimpleIconsHuaweiModule {}
